document.addEventListener("DOMContentLoaded", () => {
  const productQuickviewModal = document.querySelector("#quick-view-modal");
  const productQuickviewContent = document.querySelector(
    ".quick-view-modal-content"
  );
  const productQuickviewInner = document.querySelector(
    ".quick-view-modal-inner"
  );

  document.querySelectorAll("[data-popup-open]").forEach((button) => {
    button.removeEventListener("click", handleOpenPopup);
    button.addEventListener("click", handleOpenPopup);
  });
  function handleOpenPopup(event) {
    event.preventDefault();
    event.stopPropagation();
    const productHandle = this.dataset.handle;
    handlePopupContent(productHandle);
  }

  document.querySelectorAll("[data-popup-close]").forEach((button) => {
    button.addEventListener("click", handleClosePopup);
  });
  productQuickviewModal.addEventListener("click", function (event) {
    if (event.target === productQuickviewModal) {
      handleClosePopup();
    }
  });

  function handleClosePopup() {
    productQuickviewModal.classList.remove("active");
  }

  async function handlePopupContent(handle) {
    productQuickviewModal.classList.add("active");
    productQuickviewInner.classList.add("loading");
    productQuickviewContent.innerHTML = "";

    try {
      const response = await fetch(`/products/${handle}`);
      const data = await response.text();
      const fakeDiv = document.createElement("div");
      fakeDiv.innerHTML = data;
      const productTemplate = fakeDiv.querySelector(
        ".product-quick-view-sections"
      );
      productQuickviewContent.innerHTML = productTemplate.innerHTML;
      initImageSlider();
    } catch (error) {
      console.log("Error from handlePopupContent!", error);
    } finally {
      productQuickviewInner.classList.remove("loading");
    }
  }
  function initImageSlider() {
    const mainEl = document.querySelector("#main-quick-view-images-slider");
    const thumbEl = document.querySelector("#quick-view-thumbs-slider");

    const main = new Splide(mainEl, {
      type: "fade",
      heightRatio: 1,
      cover: true,
      pagination: false,
      arrows: true,
      breakpoints: {
        768: {
          heightRatio: 0.7,
        },
      },
    });

    const thumbnails = new Splide(thumbEl, {
      fixedWidth: 80,
      fixedHeight: 80,
      isNavigation: true,
      gap: 10,
      pagination: false,
      arrows: false,
      cover: true,
      breakpoints: {
        768: {
          fixedWidth: 60,
          fixedHeight: 60,
        },
      },
    });

    main.sync(thumbnails);

    main.mount();
    thumbnails.mount();

    const slideCount = main.Components.Slides.get().length;
    if (slideCount <= 1) {
      thumbEl.style.display = "none";
    } else {
      thumbEl.style.display = "";
    }

    main.refresh();
  }
});
